import EventTicketsPage from './container';

export default EventTicketsPage;



// WEBPACK FOOTER //
// ./app/src/components/EventTicketsPage/index.js